import React from 'react';
import parsePhoneNumber from 'libphonenumber-js';
export const getPhoneFormatterObject = (phone) => {
    if (!phone) {
        return null;
    }
    return phone[0] !== '+'
        ? parsePhoneNumber(`+${phone}`)
        : parsePhoneNumber(phone);
};
export const phoneFormatterInternational = (phone) => {
    if (!phone)
        return '';
    try {
        // if statement is for the bad acceptance data that breaks the page
        const phoneNumber = getPhoneFormatterObject(phone);
        if (!phoneNumber) {
            return phone;
        }
        return phoneNumber.format('E.164');
    }
    catch (err) {
        return '';
    }
};
export const phoneFormatterUS = (phone) => {
    if (!phone)
        return '';
    try {
        const phoneNumber = getPhoneFormatterObject(phone);
        if (!phoneNumber) {
            return phone;
        }
        if (Number(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.countryCallingCode) === 1) {
            return _constructUSNumber(phoneNumber.countryCallingCode, phoneNumber.nationalNumber);
        }
        // if doesn't follow US conventions, return in E164 international standard
        return phoneNumber.format('E.164');
    }
    catch (err) {
        return '';
    }
};
// Takes the country calling code and national number as separate args
const _constructUSNumber = (countryCode, phoneNumber) => {
    return `${countryCode}-${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 10)}`;
};
export const createPhoneNumberWithExtension = (phone, phone_extension, extTitle) => {
    if (!phone_extension || phone === '') {
        return `${phone}`;
    }
    return `${phone} ${extTitle} ${phone_extension}`;
};
